import { stringify } from 'querystring';
import React, { useState, Dispatch, SetStateAction, useEffect, useCallback } from 'react';
import {Dstring, Hstring, Lstring} from "./LetterData";
import App from "./App"
import {pages, pagesetter, GRAPHICS_GENERATOR_PAGE, WHATSAPP_SCANNER_PAGE, SPELLING_BEE_PAGE} from "./App"
import { Button } from './button';
import { Viewport } from './hooks/useWindowSize';
import { MobileHomeHero } from './components/MobileHomeHero';

const tau = 2*Math.PI

type point = {x: number, y: number};
type hsv = {h: number, s: number, v: number};
type hsl = {h: number, s: number, l: number};

//TESTING TESTING 123

//What sub-pages do we want?
//Animation, Desmos. Music/Tabs. Sculpture? ehhh.
//How to store these buttons? Maybe make a custom thing.

//So how are we gonna do page navigation? Maybe it should be a map from a string to an actual function.

function pointlisttostring(pointlist: point[]): string{
    let returnstring = ""
    for(let i = 0; i < pointlist.length; i++){
        returnstring = returnstring + pointlist[i].x.toString() + "," + pointlist[i].y.toString() + " "
    }
    return returnstring
}

function mag(p1: point, p2: point): number{
    return Math.sqrt(Math.pow(p1.x-p2.x,2)+Math.pow(p1.y-p2.y,2))
}

function sech(x: number): number{
    return 1/Math.cosh(x)
}

function bump(x: number): number{
    return 100*sech(x/100)*(1-sech(8*x/100))
}

export function distortandcenter(point: point, center: point, mouse: point, fac: number): point{
    const relmouse = {x: mouse.x-center.x, y: mouse.y-center.y}
    const fullfac = fac*bump(mag(point,relmouse))/mag(point,relmouse)
    const offset = {x: fullfac*(point.x-relmouse.x), y: fullfac*(point.y-relmouse.y)}
    return {x: point.x + center.x + offset.x, y: point.y + center.y + offset.y}
}

function getlist(x: number): point[]{
    if(x == 0){
        return Dstring
    }
    if(x == 1){
        return Hstring 
    }
    else{
        return Lstring
    }
}

function hsvtohsl(hsvin: hsv): hsl{
    const L = hsvin.v*(1-hsvin.s/2)
    let S = 0
    if(L == 0 || L == 1){
        S = 0
    }
    else{
        S = (hsvin.v-L)/Math.min(L,1-L)
    }
    return {h:hsvin.h,s: S,l: L}
}

export function getcolorstring(hsvin: hsv): string{
    const newhsl = hsvtohsl(hsvin)
    return "hsl(" + (newhsl.h).toString() + " " + (100*newhsl.s).toString() + "% " + (100*newhsl.l).toString() + "%)"
}

function linterp(a: number, b: number, t: number){
    return a + t*(b-a)
}

function clamplr(x: number,l: number, r: number){
    if(x<l){
        return l
    }
    if(x>r){
        return r
    }
    return x
}

//TODO: Figure out the minutia of this stuff right here

function boxdist(mouse: point, reccenter: point, recdims: point): number{
    return clamplr(1-(Math.abs(mouse.x-reccenter.x)/(recdims.x/2)),0,1)*clamplr(1-(Math.abs(mouse.y-reccenter.y)/(recdims.y/2)),0,1)
}


export default function Homepage(Timer: number, setPage: pagesetter, mousePosition: {x: any, y: any}, viewport: Viewport) {
    const mouse = mousePosition
    const numlayers = 8;
    let center = {x: viewport.width/2, y: 350};

    const frameweight = 16
    const framedims = {x: 420, y: 200}

    return <div key = "wrapper" className = "wrapper homepage-shell">
            <div className="homepage-tool-stack homepage-tool-stack--left">
            <button
              type="button"
              className="homepage-graphics-btn homepage-bee-btn"
              onClick={() => setPage(SPELLING_BEE_PAGE)}
              aria-label="Spelling Bee map"
              title="Spelling Bee map"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <polygon
                  points="12,2.2 19.5,6.5 19.5,15.1 12,19.4 4.5,15.1 4.5,6.5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
                <polygon
                  points="12,7.2 15.6,9.3 15.6,13.5 12,15.6 8.4,13.5 8.4,9.3"
                  fill="currentColor"
                  opacity="0.9"
                />
              </svg>
            </button>
            </div>
            <div className="homepage-tool-stack">
            <button
              type="button"
              className="homepage-graphics-btn"
              onClick={() => setPage(GRAPHICS_GENERATOR_PAGE)}
              aria-label="Graphics generator"
              title="Graphics generator"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <rect x="3" y="4" width="18" height="14" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.75" />
                <circle cx="8.5" cy="9" r="1.6" fill="currentColor" />
                <path d="M4.5 16.5 9 12l3 2.5 3.5-4.5 4 6" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
              </svg>
            </button>
            <button
              type="button"
              className="homepage-graphics-btn"
              onClick={() => setPage(WHATSAPP_SCANNER_PAGE)}
              aria-label="Chat scanner"
              title="Chat scanner"
            >
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  d="M11 2.75h2v11.1a3.25 3.25 0 1 1-2 0V2.75z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinejoin="round"
                />
                <path d="M12 5.5v7.2" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
                <circle cx="12" cy="16.75" r="1.35" fill="currentColor" />
              </svg>
            </button>
            </div>
            <div className="desktop-only">
            <svg className="svgwindow" fill = "true"
                 width="100%" height={viewport.height} aria-label="loading screen">
                    <text
                        key = {"nametitle"}
                        x = {center.x}
                        y = {75}
                        textAnchor="middle"
                        dominantBaseline="central"
                        textLength={2*framedims.x}
                        fontSize={32}
                        fill = "hsl(0 100% 100%)"
                        fontFamily='Helvetica'
                        fontWeight= "bold"
                        >
                            DYLAN HWANG LEE
                        </text>
                {Array.from(Array(pages.length).keys()).map((num) => {
                    const N = pages.length
                    const widd = 700/N
                    const recdims = {x: widd,y: 0.3*widd}
                    const reccenter = {x: center.x + (framedims.x-recdims.x/2+frameweight/2)*(num-(N-1)/2)*(2/(N-1)),y: center.y + framedims.y + 75}
                    return (
                      <g key={pages[num].name}>
                        {Button(reccenter, recdims, pages[num].name, () => { setPage(num + 1); }, mouse)}
                      </g>
                    );
                    }
                )}
                {Array.from(Array(numlayers*3).keys()).map((num) => {
                        const l0 =  Math.floor(num/3)/(numlayers-1)
                        return <polygon 
                        key= {"Letter" + num.toString()} 
                        points={pointlisttostring(getlist(num % 3).map((point: point)=>{
                            return distortandcenter(point, center, mouse, l0)
                        }))}
                        fill={getcolorstring({h: 360*(1-l0),s: 1 - l0,v: 1})}
                        opacity= {(linterp(20,80,l0)).toString() + "%"}
                        stroke = "none"
                        />
                        }
                    )}
                <rect
                key = "Frame"
                x = {center.x-framedims.x}
                y = {center.y-framedims.y}
                width = {2*framedims.x}
                height = {2*framedims.y}
                fill = "none"
                stroke = "hsl(0 0% 100%)"
                strokeWidth= {frameweight}
                />
                <text
                        key = {"contactinfo"}
                        x = {center.x}
                        y = {center.y + framedims.y + 145}
                        textAnchor="middle"
                        dominantBaseline="central"
                        fontSize={15}
                        fill = "hsl(0 100% 100%)"
                        fontFamily='Helvetica'
                        // fontWeight= "bold"
                        >
                            Contact: dhl31415926@gmail.com
                        </text>
                        <text
                        key = {"contactinfo2"}
                        x = {center.x}
                        y = {center.y + framedims.y + 165}
                        textAnchor="middle"
                        dominantBaseline="central"
                        fontSize={15}
                        fill = "hsl(0 100% 100%)"
                        fontFamily='Helvetica'
                        // fontWeight= "bold"
                        >
                            Built for Google Chrome
                        </text>
            </svg>
            </div>
            <div className="mobile-only mobile-page">
              <div className="mobile-hero">
                <h1 className="mobile-hero__title">DYLAN HWANG LEE</h1>
                <MobileHomeHero mouse={mouse} />
              </div>
              <nav className="mobile-nav-list" aria-label="Site sections">
                {pages.map((page, index) => (
                  <button
                    key={page.name}
                    type="button"
                    className="mobile-nav-button"
                    onClick={() => setPage(index + 1)}
                  >
                    {page.name}
                  </button>
                ))}
              </nav>
              <footer className="mobile-footer">
                <div>Contact: dhl31415926@gmail.com</div>
                <div>Built for Google Chrome</div>
              </footer>
            </div>
        </div>
    // Otherwise, display our main app window
}
